import omit from 'lodash/omit';
import { memo, useEffect } from 'react';
import {
  LegalLinkNames,
  createFooter,
  getLegalLinksFallback,
  getLegalLinks,
  initDictionaryCatalog,
} from '@wg/wows-common-footer/main';

import settings from '~/settings';
import { isWCFRequired } from '~/constants';
import { isChinaRealm } from '~/helpers/realm';

import styles from './Footer.scss';

import type { IFooterProps, Realm } from '@wg/wows-common-footer/types';

const init = async () => {
  const {
    realm: { languageCode, code },
    urlByRealm,
  } = settings;

  await initDictionaryCatalog({
    language: languageCode,
    dictionaryCatalog: window.i18n.catalog,
  });
  const linksConfig = getLegalLinks({
    language: languageCode,
    realm: code,
  });
  const legalLinks = getLegalLinksFallback({
    language: languageCode,
    realm: code,
    linksConfig: omit(linksConfig, LegalLinkNames.PARTNERS),
  });

  const options: IFooterProps = {
    selector: '#footer-container',
    language: languageCode,
    realm: code as Realm,
    version: '',
    dictionaryCatalog: window.i18n.catalog,
    rootUrl: '',
    legalLinks,
    onLanguageChange: ({ language, realm }) => {
      if (realm === code) {
        const url = new URL(location.href);

        url.searchParams.set('language', language);
        location.assign(url.search);
      } else {
        const url = new URL(location.pathname, urlByRealm[realm]);

        url.searchParams.set('language', language);
        location.assign(url);
      }
    },
    onClickByLink: (event: MouseEvent) => {
      event.preventDefault();
      const target = event.currentTarget as HTMLLinkElement;
      if (target.id !== 'ot-sdk-btn') {
        window.open(target.href, '_blank');
      }
    },
  };

  if (isChinaRealm()) {
    options.realms = [];
  }

  void createFooter(options);

  window.OneTrust?.initializeCookiePolicyHtml?.();
};

const Footer = () => {
  useEffect(() => {
    if (isWCFRequired) {
      void init();
    }
  }, []);

  return isWCFRequired ? <div id="footer-container" className={styles.footerWrapper} /> : null;
};

export default memo(Footer);
